module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "text-bold",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.profile.prompt')))]), _vm._v(" "), _c('div', {
    staticClass: "k6-box",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "k6-profile-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.profile.profilePhoto,
      "alt": "Profile image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "k6-profile-data"
  }, [_c('div', {
    staticClass: "segment"
  }, [_c('span', [_vm._v("@" + _vm._s(_vm.profile.username))]), _vm._v(" "), _c('h3', {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.profile.firstName) + " " + _vm._s(_vm.profile.lastName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.profile.role))])]), _vm._v(" "), _c('div', {
    staticClass: "segment segment-grid"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("pages.profile.email")) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "segment-data"
  }, [_vm._v(_vm._s(_vm.profile.email))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("pages.profile.studentId")) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "segment-data"
  }, [_vm._v(_vm._s(_vm.profile.studentId))])])]), _vm._v(" "), _c('div', {
    staticClass: "k6-profile-actions"
  }, [_c('button', {
    staticClass: "btn btn-success k6-btn",
    staticStyle: {
      "border-radius": "30px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToEdit()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("pages.profile.edit")) + " "), _c('i', {
    staticClass: "fa fa-pencil",
    staticStyle: {
      "margin-left": "10px"
    }
  })])])]), _vm._v(" "), (_vm.quizes.length) ? _c('div', {
    staticClass: "k6-profile-stats-container"
  }, [_c('div', {
    staticClass: "k6-profile-cards"
  }, _vm._l((_vm.quizes), function(quiz) {
    return _c('div', {
      staticClass: "k6-profile-card",
      style: ({
        backgroundColor: '#E7A03B',
        cursor: quiz.result !== null ? 'pointer' : 'default'
      })
    }, [_c('div', {
      staticClass: "card-data"
    }, [_c('h2', {
      staticClass: "card-title"
    }, [_vm._v(_vm._s(quiz.title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatDate")(quiz.date)))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-size": "30px",
        "font-weight": "bold",
        "margin-right": "5px"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.quizResult(quiz.result)) + "\n            ")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "graph"
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "width": "100%",
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('h3', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#444",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.$t("pages.profile.avgGrade")) + ": \n          "), _c('span', {
    staticStyle: {
      "background-color": "#E7A03B",
      "color": "white",
      "padding": "5px",
      "border-radius": "26px",
      "padding-right": "10px",
      "padding-left": "10px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.avgGrade) + " %\n          ")])])]), _vm._v(" "), _c('line-chart', {
    attrs: {
      "height": 350,
      "width": 500,
      "options": _vm.graphOptions,
      "chartData": _vm.chartData
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7d816eca", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d816eca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/ProfileGroupStats.vue
// module id = 1420
// module chunks = 1